import { parseData, post } from './common';
import { responseHandler } from '../api/api';
const checkExistingMobileCode = (payload) => {
    return post('/InternalAPI/SingleSignOnAPI.asmx/CheckExistingMobileCode', payload).then(parseData);
};
const generateWelcomeEmail = (payload) => {
    return post('/InternalAPI/SingleSignOnAPI.asmx/GenerateWelcomeEmail', payload).then(parseData);
};
const disableSSO = (payload) => {
    return post('/InternalAPI/SingleSignOnAPI.asmx/DisableSSO', payload).then(parseData);
};
const updateSSOConfiguration = (payload) => {
    return post('/InternalAPI/SingleSignOnAPI.asmx/UpdateSSOConfiguration', payload).then(parseData);
};
const getSSOModelAndWelcomeEmail = () => {
    return post('/InternalAPI/SingleSignOnAPI.asmx/GetSSOModelAndWelcomeEmail')
        .then(parseData)
        .then(responseHandler);
};
export { checkExistingMobileCode, generateWelcomeEmail, disableSSO, updateSSOConfiguration, getSSOModelAndWelcomeEmail };
